// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ZH8l","alertIcon":"ConfirmModal_alertIcon__3kaQv"};